import {HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {ToastService} from '../toast/toast-service';

export const IGNORE_400_ERROR = new HttpContextToken<boolean>(() => false);

export function http400Interceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const toastService = inject(ToastService);

  if (req.context.get(IGNORE_400_ERROR)) {
    return next(req)
  }
  return next(req).pipe(tap(event => {
  }, err => {
    handleError(err, toastService);
  }));
}

function handleError(err: HttpErrorResponse, toastService: ToastService) {
  if (err.status === 400) {
    toastService.warning(err.error?.errorMessage ?? 'Bad Request');
  }
}
